import _ from 'lodash';

export function extractMessages(translationJSON) {
    let messages = {
        '_.iwoca': 'iwoca'
    };
    navigateOnTranslationObject(translationJSON['_'], messages, '_');
    return messages;
}

function navigateOnTranslationObject(object, result, currentPath) {
    _.forOwn(object, (value, key) => {
        if (_.isObject(value)) {
            navigateOnTranslationObject(value, result, `${currentPath}.${key}`);
        } else {
            result[`${currentPath}.${key}`] = value;
        }
    });
}

export function getDayOfWeek(weekDay) {
    const weekDays = [
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
        'Sunday'
    ];

    return weekDays[weekDay];
}
